import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import FileManagerContent from "./FileManager/FileManagerContent";

import { ShepTab, ShepTabs } from "@/components/GenericComponents/ShepTab";
import {
  selectTabselectionsFileManager,
  setTabSelectionsFileManager,
} from "@/features/connections/integrationSlice";
const FileManager = () => {
  const dispatch = useDispatch();
  const tabValue = useSelector(selectTabselectionsFileManager);
  const setTabValue = (value) => dispatch(setTabSelectionsFileManager(value));
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);

    // heap.io

    const tabDict = [
      "Inbound",
      "Outbound"
    ];

    const tabLabel = tabDict[newValue];
    if (tabLabel !== undefined) {
      window.heap.track(`File Manager - Select ${tabLabel} Tab`);
    }
  };

  return (
    <Container>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "40px",
          width: "100%",
          backgroundColor: "var(--default-light)",
        }}
      >
        <ShepTabs
          variant="tertiary"
          value={tabValue}
          onChange={handleTabChange}
          aria-label="workflow tabs"
        >
          <ShepTab
            variant="tertiary"
            key="1"
            label={"Inbound"}
            iconPosition="start"
          />
          <ShepTab
            variant="tertiary"
            key="2"
            label={"Outbound"}
            iconPosition="start"
          />
        </ShepTabs>
      </div>
      <Box sx={{ maxHeight: "100%" }}>
        {tabValue === 0 && <FileManagerContent />}
        {tabValue === 1 && <FileManagerContent isOutbound={true} />}
      </Box>
    </Container>
  );
};
export default FileManager;
